import { LocalStorageEnum } from '@enums/local-storage.enum';
import { UrlEnum } from '../../enums/url.enum';

export interface Urls {
  [UrlEnum.FAREFINDER_REDIRECT_URL]: string;
  [UrlEnum.AUTH_URL]: string;
  [UrlEnum.LOGOUT_URL]: string;

  // ORDER API
  [UrlEnum.POST_SEARCH_ORDER]: string;

  // WEB API
  [UrlEnum.GET_BOOKED_FLIGHT]: string;
  [UrlEnum.GET_AFFILIATE_OPTIONS]: string;
  [UrlEnum.GET_ORDER_DETAILS]: string;
  [UrlEnum.GET_ORDER_SUMMARY]: string;
  [UrlEnum.GET_ORDER_CONFIRMATION]: string;
  [UrlEnum.GET_BOOKED_FLIGHT_TICKET_CONDITIONS]: string;
  [UrlEnum.AIRPORTS_URL]: string;

  // MYFF_BFF
  [UrlEnum.GET_ORDERS]: string;
  [UrlEnum.GET_OPTION_ORDERS]: string;
  [UrlEnum.GET_EXTRAS_INFO]: string;
  [UrlEnum.PUT_EXTRAS_INFO]: string;
  [UrlEnum.UPDATE_LOUNGE]: string;
  [UrlEnum.UPDATE_AIRPORT_ASSISTANCE]: string;
  [UrlEnum.POST_CONFIRM_EXTRAS]: string;
  [UrlEnum.GET_FINAL_BOOKED_ORDER]: string;
  [UrlEnum.GET_FINAL_ORDER_ACTION_INFO]: string;
  [UrlEnum.GET_OPTION_ORDER_LIST]: string;
  [UrlEnum.GET_OPTION_ORDER_DETAILS]: string;
  [UrlEnum.DELETE_OPTION_ORDER]: string;
  [UrlEnum.CANCEL_FLIGHT]: string;
  [UrlEnum.SPLIT_PNR]: string;
  [UrlEnum.FLIGHT_CONFIRMATION]: string;
  [UrlEnum.GET_FLIGHTS_AND_FILTERS]: string;
  [UrlEnum.POST_FLIGHT_SELECT]: string;
  [UrlEnum.POST_CHANGED_FLIGHT]: string;
  [UrlEnum.BOOKED_FLIGHT_TICKET_CONDITIONS]: string;
  [UrlEnum.VALIDATE_OPTION_ORDER]: string;
  [UrlEnum.FINALIZE_OPTION_ORDER]: string;
  [UrlEnum.PAX_CHANGE_DATA]: string;
  [UrlEnum.UPDATE_PAX_DATA]: string;
  [UrlEnum.CONFIRM_PAX_DATA]: string;
  [UrlEnum.GET_COMMON_ORDER_DETAILS]: string;
  [UrlEnum.GET_COMMON_ORDER_DETAILS_WITH_ACTION_INFO]: string;
  [UrlEnum.DELETE_COMMON_ORDER]: string;
  // BFF - Send documents
  [UrlEnum.SEND_INVOICE]: string;
  [UrlEnum.SEND_ETICKET]: string;
  [UrlEnum.GET_TICKET_CONDITIONS]: string;

  // Analytics
  [UrlEnum.SEND_FINAL_ORDER_ANALYTICS]: string;
  [UrlEnum.SEND_LOGIN_ANALYTICS]: string;
}
export class UrlConstant {
  urls: Urls = {
    [UrlEnum.FAREFINDER_REDIRECT_URL]: `[FAREFINDER_URL]?checkAuthorized=true`,
    [UrlEnum.AUTH_URL]:
      '[AUTHORIZATION_SERVER]/login?response_type=[RESPONSE_TYPE]&client_id=[CLIENT_ID]&redirect_uri=[REDIRECT_URI]&state=[STATE]&code_challenge=[CODE_CHALLENGE]&code_challenge_method=[CODE_CHALLENGE_METHOD]',
    [UrlEnum.LOGOUT_URL]: `[AUTHORIZATION_SERVER]/logout?redirect_uri=[window_origin]/login`,

    // ORDER API
    [UrlEnum.POST_SEARCH_ORDER]: '[ORDER_API]/searchorder/search',

    // WEB API
    [UrlEnum.GET_BOOKED_FLIGHT]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/BookedFlight/`,
    [UrlEnum.GET_BOOKED_FLIGHT_TICKET_CONDITIONS]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/BookedFlight/[FLIGHT_ID]/ticketConditions`,
    [UrlEnum.GET_AFFILIATE_OPTIONS]: `[WEB_API]/usersession/[${LocalStorageEnum.OM_userSessionToken}]/affiliateoptions`,
    [UrlEnum.GET_ORDER_DETAILS]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/order/[ORDER_ID]`,
    [UrlEnum.GET_ORDER_SUMMARY]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/order/[ORDER_ID]/summary`,
    [UrlEnum.GET_ORDER_CONFIRMATION]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/order/[ORDER_ID]/confirmation`,
    [UrlEnum.AIRPORTS_URL]: `[WEB_API]/[${LocalStorageEnum.OM_userSessionToken}]/lookup/SearchLocations/[query]/FlightOnly/[targetType]?locationType=Airport`,

    // MYFF_BFF
    [UrlEnum.GET_ORDERS]: '[MYFF_BFF]/Order/List',
    [UrlEnum.GET_OPTION_ORDERS]: '[MYFF_BFF]/Order/List/Options',
    [UrlEnum.PUT_EXTRAS_INFO]: `[MYFF_BFF]/Extras/UpdateBaggage`,
    [UrlEnum.UPDATE_LOUNGE]: `[MYFF_BFF]/Extras/UpdateLounge`,
    [UrlEnum.UPDATE_AIRPORT_ASSISTANCE]: `[MYFF_BFF]/Extras/UpdateAssistance`,
    [UrlEnum.GET_EXTRAS_INFO]: `[MYFF_BFF]/Extras/ExtrasInfo`,
    [UrlEnum.POST_CONFIRM_EXTRAS]: '[MYFF_BFF]/Extras/ConfirmExtras',
    [UrlEnum.GET_FINAL_BOOKED_ORDER]: `[MYFF_BFF]/FinalOrder/BookedOrder`,
    [UrlEnum.GET_FINAL_ORDER_ACTION_INFO]: `[MYFF_BFF]/FinalOrder/ActionInfo`,
    [UrlEnum.GET_OPTION_ORDER_LIST]: `[MYFF_BFF]/OptionOrder/OptionOrderList`,
    [UrlEnum.GET_OPTION_ORDER_DETAILS]: `[MYFF_BFF]/OptionOrder/OptionOrderDetails`,
    [UrlEnum.DELETE_OPTION_ORDER]: `[MYFF_BFF]/OptionOrder/CancelOptionOrder`,
    [UrlEnum.CANCEL_FLIGHT]: `[MYFF_BFF]/FlightChange/CancelFlight`,
    [UrlEnum.GET_FLIGHTS_AND_FILTERS]: '[MYFF_BFF]/FlightChange/FlightChangeResults',
    [UrlEnum.SPLIT_PNR]: `[MYFF_BFF]/FlightChange/Split`,
    [UrlEnum.FLIGHT_CONFIRMATION]: `[MYFF_BFF]/FlightChange/Confirmation`,
    [UrlEnum.POST_FLIGHT_SELECT]: '[MYFF_BFF]/FlightChange/SelectedFlight',
    [UrlEnum.POST_CHANGED_FLIGHT]: '[MYFF_BFF]/FlightChange/ChangedFlight',
    [UrlEnum.BOOKED_FLIGHT_TICKET_CONDITIONS]: '[MYFF_BFF]/OptionOrder/GetTicketConditions',
    [UrlEnum.VALIDATE_OPTION_ORDER]: '[MYFF_BFF]/Order/ValidateOptionOrder',
    [UrlEnum.FINALIZE_OPTION_ORDER]: '[MYFF_BFF]/Order/FinalizeOptionOrder',
    [UrlEnum.PAX_CHANGE_DATA]: '[MYFF_BFF]/PaxChange/Passengers',
    [UrlEnum.UPDATE_PAX_DATA]: '[MYFF_BFF]/PaxChange/PassengerUpdate',
    [UrlEnum.CONFIRM_PAX_DATA]: '[MYFF_BFF]/PaxChange/ConfirmPassengerUpdate',
    [UrlEnum.GET_COMMON_ORDER_DETAILS]: '[MYFF_BFF]/Order/Details',
    [UrlEnum.GET_COMMON_ORDER_DETAILS_WITH_ACTION_INFO]: '[MYFF_BFF]/Order/ActionInfo',
    [UrlEnum.DELETE_COMMON_ORDER]: '[MYFF_BFF]/Order/CancelOptionOrder',
    // Send documents to order api via BFF
    [UrlEnum.SEND_INVOICE]: '[MYFF_BFF]/Order/SendInvoice',
    [UrlEnum.SEND_ETICKET]: '[MYFF_BFF]/Order/SendETicket',
    [UrlEnum.GET_TICKET_CONDITIONS]: '[MYFF_BFF]/FlightConditions',

    // Analytics
    [UrlEnum.SEND_FINAL_ORDER_ANALYTICS]: '[MYFF_BFF]/Analytics/FinalOrderAnalytics',
    [UrlEnum.SEND_LOGIN_ANALYTICS]: '[MYFF_BFF]/Analytics/LoginAnalytics',
  };
}
